import { EarningsDataEnum, EarningsEstimateType, EarningsTimeframeEnum } from '../earnings-common/types'
import { EarningsSettings } from './types'

export enum EarningsColor {
  cursor = 'cursor',
  downBar = 'downBar',
  downRevision = 'downRevision',
  estimate = 'estimate',
  lowHigh = 'lowHigh',
  price = 'price',
  upBar = 'upBar',
  upRevision = 'upRevision',
}

export const EarningsEstimateTypeLabels: { [key in EarningsEstimateType]: string } = {
  [EarningsEstimateType.eps]: 'EPS',
  [EarningsEstimateType.epsGaap]: 'GAAP EPS',
  [EarningsEstimateType.sales]: 'Sales',
}

export const EARNINGS_DATE_FORMAT = 'MMM dd, yyy'

export const PRICE_REVISIONS_CHART_WIDTH = 1218
export const PRICE_REVISIONS_CHART_HEIGHT = 296
export const REVISIONS_LEFT_TICK_STYLE = { fontSize: 10, fontWeight: 400, textAnchor: 'end' }
export const REVISIONS_RIGHT_TICK_STYLE = { fontSize: 10, fontWeight: 400, textAnchor: 'start' }
export const PRICE_REVISIONS_YAXIS_WIDTH = 40
export const PRICE_REVISIONS_TICK_COUNT = 6

export const UPDOWN_REVISIONS_CHART_HEIGHT = 135
export const UPDOWN_REVISIONS_TICK_COUNT = 7

export const FISCAL_YEAR_MARK = 'FY'

export const SETTINGS_COOKIE_KEY = 'earningsSettings'

export const DEFAULT_SETTINGS: EarningsSettings = {
  [EarningsDataEnum.yoyChange]: false,
  [EarningsDataEnum.yoyChangePct]: false,
  estimateType: EarningsEstimateType.eps,
  fiscalPeriod: '',
  earningsTimeframe: EarningsTimeframeEnum.quarterly,
}
